import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './styles.scss';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

interface Props {
  baseClassName?: string;
  buttons?: Array<React.ReactElement>;
  children: React.ReactNode;
  breadcrumb?: React.ReactNode;
  error?: string;
  loading?: boolean;
  show: boolean;
  size?: any;
  title: string;
  onClose: any;
  closeButton?: boolean;
}

const BaseModal: React.FC<Props> = ({
  baseClassName = null,
  buttons = [],
  children,
  breadcrumb,
  error = '',
  loading = false,
  show,
  size,
  title,
  onClose,
  closeButton = true,
}) => {
  return (
    <Modal
      backdrop="static"
      dialogClassName={`base-modal${baseClassName !== null ? ` ${baseClassName}` : ''}`}
      show={show}
      size={size}
      onHide={onClose}
    >
      <Modal.Header closeButton={closeButton}>
        <Modal.Title>
          {title}
          {breadcrumb}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {buttons.length > 0 && (
        <Modal.Footer>
          {error !== '' && <Alert variant="danger">{error}</Alert>}
          {loading && <Spinner animation="border" className="spinner" size="sm" />}
          {buttons.map((button, index) => React.cloneElement(button, { key: index }))}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default BaseModal;
